<div class="contact-us-content px-4 py-5">
  <h2 class="mb-4">Contact Us</h2>
  <ng-container *ngFor="let contact of contacts">
    <div>
      <img
        [src]="contact.flag_source"
        alt="contact.title"
        class="me-2"
        style="margin-top: -6px; width: 24px"
      />
      <h3 class="d-inline">{{ contact.title | uppercase }}</h3>
      <p class="pt-2 fw-bolder">{{ contact.registration.message }}</p>
      <p *ngIf="contact.registration.email">Email:
        <a [href]="mailto(contact.registration.email)" target="_blank">{{
          contact.registration.email
        }}</a>
      </p>
      <p *ngIf="contact.registration.phone">
        Phone: {{ contact.registration.phone }}
      </p>
      <p class="pt-2 fw-bolder">
        {{ contact.claim.message }}
      </p>
      <p *ngIf="contact.claim.email">
        Email:
        <a [href]="mailto(contact.claim.email)" target="_blank">{{
          contact.claim.email
        }}</a>
      </p>
      <p *ngIf="contact.claim.phone">Phone: {{ contact.claim.phone }}</p>
    </div>
  </ng-container>
</div>
